<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    bottom
    left
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon large="large">
          <v-badge avatar overlap color="transparent" v-if="employee.owner || (employee.metadata && employee.metadata.timeClockLogin && employee.metadata.timeClockLogin.admin)">
            <template v-slot:badge>
              <v-avatar >
                <v-icon small color="yellow darken-4" v-if="employee.owner">mdi-crown</v-icon>
                <v-icon small color="yellow darken-4" v-else-if="employee.metadata.timeClockLogin.admin">mdi-account-circle</v-icon>
              </v-avatar>
            </template>

            <v-avatar size="30">
              <v-img :src="getImage"></v-img>
            </v-avatar>
          </v-badge>


          <v-avatar size="30" v-else>
            <img
              :src="getImage"
              alt="User"
            />
            <!-- <img v-else src="@/assets/images/user.jpeg" alt="User" /> -->
          </v-avatar>
        </v-btn>
      <!-- <v-avatar color="primary" size="30" v-bind="attrs" v-on="on">
        <img :src="getImage" class="image" alt="EmployeeImage" />
      </v-avatar> -->
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <!-- <v-badge avatar overlap color="transparent" v-if="employee.owner || (employee.metadata && employee.metadata.timeClockLogin && employee.metadata.timeClockLogin.admin)">
            <template v-slot:badge>
              <v-avatar >
                <v-icon small color="yellow darken-4" v-if="employee.owner">mdi-crown</v-icon>
                <v-icon small color="yellow darken-4" v-else-if="employee.metadata.timeClockLogin.admin">mdi-account-circle</v-icon>
              </v-avatar>
            </template>

            <v-avatar size="30">
              <v-img :src="getImage"></v-img>
            </v-avatar>
          </v-badge> -->
            <img :src="getImage" class="image" alt="EmployeeImage" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ employee.name }}</v-list-item-title>
            <v-list-item-subtitle>
              <v-icon small color="yellow darken-4" v-if="employee.owner">mdi-crown</v-icon>
              <span>Admin</span></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn color="primary" icon @click="moveToProfile">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item to="/login/location" v-if="employeeAccess.setting && employeeAccess.setting.switchLocation">
          <v-list-item-action>
            <v-icon>mdi-shield-key</v-icon>
          </v-list-item-action>
          <v-list-item-title>Switch Location</v-list-item-title>
        </v-list-item>
        <v-list-item to="/backoffice" v-if="employeeAccess.setting && employeeAccess.setting.account">
          <v-list-item-action>
            <v-icon>mdi-shield-account</v-icon>
          </v-list-item-action>
          <v-list-item-title>Account</v-list-item-title>
        </v-list-item>

        <!-- <v-list-item>
            <v-list-item-action>
              <v-switch v-model="hints" color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable hints</v-list-item-title>
          </v-list-item> -->
      </v-list>
<v-divider></v-divider>
      <v-card-actions>

        <v-btn color="secondary" block to="/logout"> Logout </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import UserImg from "@/assets/images/user.jpeg";
import { mapGetters } from "vuex";

export default {
  name: "app-menu-bar",
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    moveToProfile() {
      console.log("lastEmployee", this.employee);
      if (this.employee && this.employee.id) {
        const id = this.employee.id;
        return this.$router.push({ name: "employee-edit", params: { id: id } });
      }
      return false;
    },
  },
  created() {
    console.log('employee', this.employee)
  },
  computed: {
    ...mapGetters("employee", ["employee", "employeeAccess"]),
    getImage() {
      if (this.employee && this.employee.imageURL) {
        return this.employee.imageURL;
      } else return UserImg;
    },
  },
};
</script>

<style scoped>
</style>